// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const trebuchet = defineModel({
  id: "trebuchet",
  batchId: "future",
  name: "Trebuchet",
  tags: ["scenery","trebuchet","low-poly","age-of-mcp","future","military"],
  summary: "A trebuchet — a counterweight siege engine (parked: no combat yet).",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.55,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.8, 0.07, 0.08), color: "#7a512c", position: [0, 0.04, 0.22] },
      { geometry: new THREE.BoxGeometry(0.8, 0.07, 0.08), color: "#7a512c", position: [0, 0.04, -0.22] },
      { geometry: new THREE.BoxGeometry(0.1, 0.07, 0.5), color: "#7a512c", position: [0, 0.04, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.92, 0.05), color: "#5c3c20", position: [-0.16, 0.475, 0.2], rotation: [0, 0, 0.32] },
      { geometry: new THREE.BoxGeometry(0.05, 0.92, 0.05), color: "#5c3c20", position: [0.16, 0.475, 0.2], rotation: [0, 0, -0.32] },
      { geometry: new THREE.BoxGeometry(0.05, 0.92, 0.05), color: "#5c3c20", position: [-0.16, 0.475, -0.2], rotation: [0, 0, 0.32] },
      { geometry: new THREE.BoxGeometry(0.05, 0.92, 0.05), color: "#5c3c20", position: [0.16, 0.475, -0.2], rotation: [0, 0, -0.32] },
      { geometry: new THREE.CylinderGeometry(0.018, 0.018, 0.5, 6), color: "#3a3f44", position: [0, 0.85, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.BoxGeometry(1, 0.05, 0.05), color: "#7a512c", position: [0.12, 0.91, 0], rotation: [0, 0, -0.5] },
      { geometry: new THREE.BoxGeometry(0.22, 0.24, 0.24), color: "#5a5550", position: [-0.28, 0.63, 0] },
      { geometry: new THREE.CylinderGeometry(0.008, 0.008, 0.14, 4), color: "#3a3f44", position: [-0.26, 0.8, 0.08] },
      { geometry: new THREE.CylinderGeometry(0.008, 0.008, 0.14, 4), color: "#3a3f44", position: [-0.26, 0.8, -0.08] },
      { geometry: new THREE.CylinderGeometry(0.006, 0.006, 0.5, 4), color: "#b8a479", position: [0.46, 0.87, 0], rotation: [0, 0, 0.7] },
      { geometry: new THREE.SphereGeometry(0.05, 6, 5), color: "#7d776b", position: [0.6, 0.07, 0] },
    ],
  animations: [],
});
